import script from "./QueryView.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryView.vue?vue&type=script&setup=true&lang=js"

import "./QueryView.vue?vue&type=style&index=0&id=7f0f61d5&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f0f61d5"]])

export default __exports__